// ============================================================================
//  Helpers de cliente compartidos — fetch JSON con manejo de error consistente
//  y un toast simple. Primer código de cliente que hace peticiones mutantes
//  (POST); client/pages/index.ts puede adoptarlo más adelante.
// ============================================================================
export async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`error ${res.status} al cargar ${url}`);
  return (await res.json()) as T;
}

export async function postJson(url: string, body: unknown): Promise<boolean> {
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (res.ok) {
      toast('Guardado');
      return true;
    }
    const data = (await res.json().catch(() => ({}))) as { error?: string };
    toast(data.error || `error ${res.status} al guardar`, true);
    return false;
  } catch {
    toast('Sin conexión con el servidor', true);
    return false;
  }
}

export async function delJson(url: string): Promise<boolean> {
  try {
    const res = await fetch(url, { method: 'DELETE' });
    if (res.ok) {
      toast('Eliminado');
      return true;
    }
    const data = (await res.json().catch(() => ({}))) as { error?: string };
    toast(data.error || `error ${res.status} al eliminar`, true);
    return false;
  } catch {
    toast('Sin conexión con el servidor', true);
    return false;
  }
}

let toastTimer: ReturnType<typeof setTimeout> | null = null;

export function toast(message: string, isError = false): void {
  const el = document.getElementById('toast');
  if (!el) return;
  el.textContent = message;
  el.className = isError ? 'toast show err' : 'toast show';
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('show'), isError ? 4200 : 2200);
}

export function esc(s: string): string {
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };
  return String(s ?? '').replace(/[&<>"']/g, (c) => map[c] ?? c);
}
